import IconTransfer from "@Icons/transportType/IconTransfer";
import IconType from "@/types/Icon.type";

/**
 * Ticket car addon icon
 * Copy of a transport type Icon for transfers
 */
function IconCar(props: IconType) {
    return (
        <IconTransfer
            {...props}
        />
    )
}

export default IconCar;